function initModals() {
    var body = document.body;
    const modals = document.querySelectorAll('.modal');
    const openModalButtons = document.querySelectorAll('.open-modal');
    const closeModalButtons = document.querySelectorAll('.close-modal');

    openModalButtons.forEach(openModalButton => {
        openModalButton.addEventListener('click', () => {
            const currentModal = document.querySelector(`.modal[data-modal='${openModalButton.id}']`);
            currentModal.classList.add('show');
            body.classList.add('overflow-y-hidden');
        })
    })
    
    closeModalButtons.forEach(closeModalButton => {
        closeModalButton.addEventListener('click', () => {
            const modal = closeModalButton.getAttribute('data-modal');

            const currentModal = document.querySelector(`.modal[data-modal='${modal}']`);
            currentModal.classList.remove('show');
            body.classList.remove('overflow-y-hidden');
        })
    })

    modals.forEach(modal => {
        modal.addEventListener('click', (event) => {
            const isOutside = !event.target.closest('.modal-inside');
            if (isOutside) {
              modal.classList.remove('show');
              body.classList.remove('overflow-y-hidden');
            }
        })
    })
}

export { initModals }
